export function isObject<T>(value: T): value is T & Record<string, unknown> {
    return typeof value === "object" && value !== null;
}

export function isObjectWithKey<T, TKey extends string>(value: T, key: TKey): value is T & { [key in TKey]: unknown } {
    return isObject(value) && key in value;
}
